var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Text, Flex, Icon } from "./..";
export var DropdownMenuItem = function (_a) {
    var icon = _a.icon, text = _a.text, containerLss = _a.containerLss, iconLss = _a.iconLss, textLss = _a.textLss;
    return (React.createElement(Flex, { lss: __assign({ alignItems: 'center' }, containerLss) },
        icon && (React.createElement(Icon, { as: icon, size: 20, lss: __assign({ color: 'secondary500' }, iconLss) })),
        text && (React.createElement(Text, { lss: __assign({ textScale: 'control', ml: 'sm', color: 'primary500', ':hover': { color: 'secondary500' } }, textLss) }, text))));
};
//# sourceMappingURL=DropdownMenuItem.js.map